import {
    exportFeatures as exportFeaturesAT,
    transactions as transactionsAT,
} from './lib/featuresConfig/AT';
import {
    exportFeatures as exportFeaturesBase,
    transactions as transactionsBase,
} from './lib/featuresConfig/base';
import {
    exportFeatures as exportFeaturesCZ,
    transactions as transactionsCZ,
} from './lib/featuresConfig/CZ';
import {
    exportFeatures as exportFeaturesHR,
    transactions as transactionsHR,
} from './lib/featuresConfig/HR';
import {
    exportFeatures as exportFeaturesHU,
    transactions as transactionsHU,
} from './lib/featuresConfig/HU';
import {
    exportFeatures as exportFeaturesRO,
    transactions as transactionsRO,
} from './lib/featuresConfig/RO';
import {
    exportFeatures as exportFeaturesRS,
    transactions as transactionsRS,
} from './lib/featuresConfig/RS';
import {
    exportFeatures as exportFeaturesSK,
    transactions as transactionsSK,
} from './lib/featuresConfig/SK';

export { features, shorthandFeatures } from './lib/features/features';
export { features as miscellaneousFeatures } from './lib/features/miscellaneous';
export type {
    RetailTransactionsFeatures as TransactionsFeatures,
    RetailTransactionsShorthandFeatures as TransactionsShorthandFeatures,
} from './lib/types/RetailTransactionsFeatures';
export type { MiscellaneousFeatures } from './lib/types/MiscellaneousFeatures';

export const exportFeatures = {
    AT: exportFeaturesAT,
    base: exportFeaturesBase,
    CZ: exportFeaturesCZ,
    HR: exportFeaturesHR,
    HU: exportFeaturesHU,
    RO: exportFeaturesRO,
    RS: exportFeaturesRS,
    SK: exportFeaturesSK,
};

export const transactions = {
    AT: transactionsAT,
    base: transactionsBase,
    CZ: transactionsCZ,
    HR: transactionsHR,
    HU: transactionsHU,
    RO: transactionsRO,
    RS: transactionsRS,
    SK: transactionsSK,
};

export { RetailTransactionsRouteParts } from './lib/RetailTransactionsRouteParts';
